<template>
    <div class="numPool">
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>

        <!-- 筛选条件 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-input
                            v-model="searchForm.iccid"
                            placeholder="输入号卡iccid号"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.phoneNumber"
                            placeholder="输入绑定号码"
                            @keyup.enter.native="handleSearch"
                            maxlength="11" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.memberCode"
                            placeholder="输入网点账号"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>


                <el-form-item>
                    <el-select  v-model="searchForm.cardType"
                                placeholder="选择号卡类型"
                                clearable filterable>
                        <el-option  v-for="item in cardTypeNameOptions" 
                                    :key="item.CODE_NUM"
                                    :label="item.NAME"
                                    :value="item.CODE_NUM"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select  v-model="searchForm.operatorType"
                                placeholder="选择运营商"
                                clearable filterable>
                        <el-option  v-for="item in operatorTypeNameOptions"
                                    :key="item.CODE_NUM"
                                    :label="item.NAME"
                                    :value="item.CODE_NUM"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select  v-model="searchForm.cardStatus"
                                placeholder="选择状态"
                                clearable filterable>
                        <el-option  v-for="item in cardStatusNameOptions"
                                    :key="item.CODE_NUM"
                                    :label="item.NAME"
                                    :value="item.CODE_NUM"
                        ></el-option>
                    </el-select>
                </el-form-item>

            </template>
        </sr-filter>

        <!-- 表格 -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">配置列表</span>
                <span class="top_ri">
                    <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                        <i class="exportIcon"></i>
                        <span>导出</span>
                    </button>
                    <button class="butStyle greenBtn importBtn" @click="showImportDialog">
                        <i class="importIcon"></i>
                        <span>导入</span>
                    </button>
                </span>
            </div>
            <el-table :data="tableData"
                        style="width: 100%;"
                        border
                        fit
                        highlight-current-row
                        tooltip-effect="dark"
            >
<!--                <el-table-column label="id" prop="id" min-width="140" header-align="center" align="center" disabled="true"-->
<!--                                show-overflow-tooltip></el-table-column>-->
                <el-table-column label="号卡类型" prop="cardTypeName" min-width="140" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="运营商" prop="operatorTypeName" min-width="120" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="iccid" prop="iccid" min-width="200" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" prop="cardStatusName" min-width="100" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
<!--                <el-table-column label="当前套餐" prop="package" width="220" header-align="center" align="center"-->
<!--                                show-overflow-tooltip></el-table-column>-->
                <el-table-column label="绑定号码" prop="phoneNumber" min-width="140" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="用户" prop="userMemberName" min-width="120" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="网点账号" prop="memberCode" min-width="140" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="160" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="showDelDialog(scope)" class="orangeText"
                                   icon="fa fa-trash" type="text" title="删除"
                        >删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="searchForm.page" :page-sizes="[10, 20, 30]"
                                :page-size="searchForm.rows"
                                layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>


        <!-- 导入弹窗-start -->
        <el-dialog width="500px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
                :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
            <el-form ref="form" :rules="rules" :model="postForm" label-width="92px" style="position:relative;">
                
                    <!-- <el-row>
                        <el-col :span="24">
                            <el-form-item label="运营商：" prop="operatorTypeName">
                                <el-radio v-model="postForm.operatorTypeName"
                                          label="1">
                                    中国移动
                                </el-radio>
                                <el-radio v-model="postForm.operatorTypeName"
                                          label="2">
                                    中国联通
                                </el-radio>
                                <el-radio v-model="postForm.operatorTypeName"
                                          label="3">
                                    中国移动
                                </el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row> -->

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="上传文件：" prop="fieldId">
                                <el-upload
                                        action=""
                                        :show-file-list="false"
                                        :before-upload="beforeUpload"
                                        :on-success="handleUploadSuccess"
                                        :on-error="handleUploadError"
                                        :http-request="onUpload"
                                >
                                    <template>
                                        <el-button size="small" class="uploadBtn">
                                            <span>请上传文件</span>
                                            <i class="el-icon-upload el-icon--right"></i>
                                        </el-button>
                                        <span slot="tip" class="uploadTip">
                                            只能上传excel式文件
                                        </span>
                                    </template>
                                </el-upload>
                                <a @click="downloadTemplate" class="uploadTemplate">点击下载模板</a>
                            </el-form-item>
                        </el-col>
                    </el-row>

            </el-form>

            <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">退 出</button>
<!--                    <button @click="validateForm" class="butStyle refuseOBtn">保 存</button>-->
                </div>
            </span>
        </el-dialog>
        <!-- 导入弹窗-end -->

    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter';
    import {objectToQueryString} from '@/utils/commonUtils.js';
    import {
        cardList, // 号卡列表
        deleteCard, // 删除号卡
        upload, // 号卡导入
        cardListExport, // 号卡导出
        download, // 下载号卡导入模板
        getCardType, // 获取号卡类型
        getOperatorType, // 获取运营商类型
        getCardStatus, // 获取号卡状态
    } from '@/api/Resource/numCardManage.js';


    // 添加/编辑弹窗的数据
    const defaultPostForm = {
        // operatorTypeName: '1', //运营商
        fieldId: null, //文件id
    }

    // 搜索表格的条件
    const searchConst = {
        iccid: null, //iccid号
        phoneNumber: null, //绑定号码
        memberCode: null, //网点账号
        cardTypeName: null, //号卡类型
        operatorType: null, //运营商
        cardStatus: null, //状态
        page: 1, //当前页码
        rows: 10, //每页条数
    }

    export default {
        name: "numPoolIndex",
        data() {
            return {
                timeRange: null,
                //标题
                topTitle: {
                    title: '号卡管理',
                    subTit: '号码池',
                    thirdTit: '',
                },
                // 表格搜索条件
                searchForm: Object.assign({}, searchConst),
                // 号卡类型
                cardTypeNameOptions: [
                ],
                // 运营商
                operatorTypeNameOptions: [
                ],
                // 状态
                cardStatusNameOptions: [
                ],

                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,

                // 导入弹窗数据
                postForm: Object.assign({}, defaultPostForm),
                // 添加/编辑窗口是否显示
                dialogFormVisible: false,
                // 弹窗标题
                dialogMap: {
                    import: '号卡导入',
                },
                dialogTitle: '',
                // 弹窗校验规则
                rules: {
                    // operatorTypeName: [{required: true, message: '请选择运营商', trigger: 'blur'}],
                    fieldId: [{required: true, message: '请上传号卡文件', trigger: 'blur'}],
                },

            }
        },
        components: {
            SrFilter
        },
        created() {
            this.getCardType();
            this.getOperatorType();
            this.getCardStatus();
            this.cardList()
        },
        methods: {
            tableExport() {
                const url = `${this.$baseNewUrl}esaleb-service-resource/res-card-iccid/cardListExport?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm)}`;
                window.open(url, '_blank');
            },
           
            // 获取列表数据
            async cardList() {
                try {
                    console.log('this.searchForm', this.searchForm);
                    const resp = await cardList(this.searchForm);
                    this.tableData = resp.data.records;
                    this.total = parseInt(resp.data.total);
                } catch (e) {
                    console.log(e)
                }
            },

            async getCardType() {
                try {
                    const resp = await getCardType({});
                    this.cardTypeNameOptions = resp.data;
                } catch (e) {
                    console.log(e)
                }
            },

            async getOperatorType() {
                try {
                    const resp = await getOperatorType({});
                    this.operatorTypeNameOptions = resp.data;
                } catch (e) {
                    console.log(e)
                }
            },

            async getCardStatus() {
                try {
                    const resp = await getCardStatus({});
                    this.cardStatusNameOptions = resp.data;
                } catch (e) {
                    console.log(e)
                }
            },

            // 列表过滤查询
            handleSearch() {
                this.cardList()
            },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
                this.searchForm = Object.assign({}, searchConst)
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.rows = val
                this.cardList()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.page = val
                this.cardList()
            },

            // 弹出“删除”确认框
            showDelDialog(data) {

                const rowData = JSON.parse(JSON.stringify(data.row))
                // 通过当前ID请求更多的数据
                // this.getDetail(rowData.ID)
                var delParams = {
                    id: rowData.id
                }
                var $this = this
                    this.$confirm('删除号卡将无法恢复，确定操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $this.delNumCard(delParams, '删除成功！')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除操作'
                    })
                })
            },

            // 删除号卡
            async delNumCard(params, msg) {
                try {
                    console.log('delNumCard',params)
                    const resp = await deleteCard(params)
                    if (resp && resp.code != 0) {
                        this.$message.error(resp.msg)
                        return
                    }
                    this.$message.success(msg)
                    // if (this.tableData.length == 1 && this.selectedRow.index == 0 && this.searchForm.current > 1) {
                    //     this.searchForm.current = 1
                    // }
                    this.cardList()
                } catch (e) {
                    console.log(e)
                }
            },


            // 弹出导入弹窗
            showImportDialog() {
                this.dialogTitle = 'import'
                this.dialogFormVisible = true
            },

            // 弹窗关闭前
            beforeClose() {
                this.resetData()
            },
            // 关闭弹窗
            closeDialog() {
                this.resetData()
            },
            // 重置表单
            resetData() {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
                this.postForm = Object.assign({}, defaultPostForm)
            },

            // 验证表单-点击弹窗的“确定”按钮
            validateForm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitForm()
                    } else {
                        this.dialogFormVisible = true
                    }
                })
            },
            // 提交表单
            async submitForm() {
            },


            // 下载号卡导入模板
            async downloadTemplate() {
                try {
                    // const resp = await download()
                    // if (!resp || (resp && resp.code != 0)) {
                    //     this.$message.error('下载失败！');
                    //     return
                    // }
                    // let blob = new Blob([resp], {type: 'application/vnd.ms-excel'})
                    // let link = document.createElement('a');
                    // link.href = URL.createObjectURL(blob)
                    // link.download = '号卡导入模板';
                    // link.click()
                    const url = `${this.$baseNewUrl}esaleb-service-resource/res-card-iccid/download?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm)}`;
                    window.open(url, '_blank');
                } catch (e) {
                    console.log(e)
                }
            },

            // 号卡导入(上传文件)
            onUpload (uploadObj) {
                let file = uploadObj.file
                let param = new FormData()
                param.append('file', file)
                console.log('uploadObj', uploadObj)

                upload(param).then(resp => {
                    if (resp && resp.code != 0) {
                        this.$message.error(resp.msg)
                        return
                    }
                    this.$message.success('号卡导入成功')
                    this.closeDialog()
                    this.cardList()
                }).catch(err => {
                    console.log(err)
                })
            },
            // 文件上传成功时的钩子
            handleUploadSuccess(res, file) {
                console.log('Success-res', res)
                console.log('Success-file', file)
                // this.postForm.fieldId = URL.createObjectURL(file.raw);
                // this.postForm.fieldId = file[0].id
            },
            // 文件上传失败时的钩子
            handleUploadError(res, file) {
                console.log('Error-res', res)
                console.log('Error-file', file)

                this.$message.error('文件上传失败！')
                this.$alert('文件上传失败！', '上传失败提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    showClose: false,
                    dangerouslyUseHTMLString: true
                })
            },
            beforeUpload(file) {
                console.log(file)
                const isXls = file.type === 'application/vnd.ms-excel';
                const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isXls && !isXlsx) {
                    this.$message.error('只能上传xls/xlsx文件!');
                    // this.$message.error('导入文件只能是 xls 或 xlsx 格式!')
                    // this.$message.error('请上传excel文件!')
                }
                if (!isLt2M) {
                  this.$message.error('文件大小不能超过 2MB!');
                }
                var check = isLt2M && (isXls || isXlsx);
                // console.log(check)
                return check;
            },


        },
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.orangeText {
    color:#FA6241;
}

.numPool {

}

// 标题
.numPool .titleBox {
    width: 100%;
    // background: #FBFBFB;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 筛选框
.numPool .searchBox {
    margin-top: 1px;
}

// 表格
.numPool .botTable {
    margin-top: 12px;
    width: 100%;
}

.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}

.botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
}

.botTable .tableTop .top_ri {
    font-size: 12px;
    color: #4E4A46;
}

.botTable .tableTop .top_ri b {
    font-size: 20px;
    font-weight: normal;
    color: #FFCC00;
}

.botTable .tableTop .top_ri .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
}

.botTable .tableTop .top_ri .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
}

.botTable .tableTop .top_ri .importBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #2DBAA5;
    &:hover {
      background-color: rgb(126, 187, 178);
    }
}

.botTable .tableTop .top_ri .importBtn .importIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/resource/NumCardManage/importIcon.png') no-repeat;
    background-size: 14px 14px;
}

/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}


// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #FFFFFF;
    // background: #FA6241;
    // &:hover {
    //   background-color: rgb(247, 143, 120);
    // }
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}


.uploadBtn {
    font-size: 12px;
    color: #ffffff;
    border: none;
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}
.uploadTip {
//   display: inline;
    font-size: 12px;
    color: #AAAAAA;
    margin-left: 12px;
}
.uploadTemplate {
    display: inline;
    cursor: pointer;
    font-size: 12px;
    color: #2DBAA5;
    text-decoration: none;
}
.uploadTemplate :active {
    color: rgb(134, 189, 180);
}



</style>
